import { useState } from "react";
import { EyeOff } from "lucide-react";
import { cn } from "@/lib/utils";

/** Blurs spoiler text behind a warning until the reader clicks to reveal it. */
export const SpoilerText = ({ text, spoiler, className }: { text: string; spoiler?: boolean | null; className?: string }) => {
  const [revealed, setRevealed] = useState(false);
  if (!spoiler || revealed) return <p className={cn("whitespace-pre-wrap", className)}>{text}</p>;
  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); setRevealed(true); }}
      className="relative block min-h-[4.5rem] w-full overflow-hidden rounded-md border border-marquee-bulb/20 bg-muted/40 text-left"
      aria-label="Spoiler hidden. Click to reveal."
    >
      <p className={cn("whitespace-pre-wrap select-none p-3 blur-md", className)} aria-hidden="true">{text}</p>
      <span className="absolute inset-0 flex flex-col items-center justify-center gap-1 px-3 py-2 bg-background/40 text-center">
        <span className="flex items-center gap-1.5 text-xs font-black uppercase tracking-[0.2em] text-marquee-bulb">
          <EyeOff className="h-3.5 w-3.5" /> Spoiler warning
        </span>
        <span className="text-xs text-muted-foreground">Click to reveal</span>
      </span>
    </button>
  );
};

export default SpoilerText;
